import { isAxiosError } from 'axios';

const ANONYMIZATION_MARKER = '__practium_anonymization_pending';

export interface AnonymizationPendingInfo {
	message: string;
	anonymizeAt: string | null;
	canCancelUntil: string | null;
	waitDays: number;
	remainingDays: number;
	jobTime?: string;
}

export type AnonymizationPendingError = Error & AnonymizationPendingInfo;

export function createAnonymizationPendingError(info: AnonymizationPendingInfo): AnonymizationPendingError {
	const err = new Error(info.message) as AnonymizationPendingError & Record<string, unknown>;
	err[ANONYMIZATION_MARKER] = true;
	err.anonymizeAt = info.anonymizeAt;
	err.canCancelUntil = info.canCancelUntil;
	err.waitDays = info.waitDays;
	err.remainingDays = info.remainingDays;
	err.jobTime = info.jobTime;
	return err;
}

export function toAnonymizationPendingError(error: unknown): AnonymizationPendingError | null {
	if (!isAxiosError(error)) return null;
	const data = error.response?.data as (Partial<AnonymizationPendingInfo> & { code?: string; message?: string }) | undefined;
	if (error.response?.status !== 423 || data?.code !== 'ANONYMIZATION_PENDING') return null;

	return createAnonymizationPendingError({
		message: data.message ?? 'Esta conta possui uma solicitação de exclusão pendente.',
		anonymizeAt: data.anonymizeAt ?? null,
		canCancelUntil: data.canCancelUntil ?? null,
		waitDays: data.waitDays ?? 0,
		remainingDays: data.remainingDays ?? 0,
		jobTime: data.jobTime,
	});
}

export function isAnonymizationPending(err: unknown): err is AnonymizationPendingError {
	return (
		err !== null &&
		typeof err === 'object' &&
		(err as Record<string, unknown>)[ANONYMIZATION_MARKER] === true
	);
}
